import React, { useState } from 'react';
import { Swiper } from 'swiper/react';

import {
  LeftArrow,
  LeftArrowContainer,
  RightArrow,
  RightArrowContainer,
} from '../../../productsSliderSection/productsSliderSection.styled';
import ArrowIcon from '../../images/arrow.svg';

import { SliderData } from './slider.types';

export const Slider: React.FC<SliderData> = (data: SliderData) => {
  const { children } = data;
  const [controlledSwiper, setControlledSwiper] = useState(null);
  const [isLeftArrowVisible, setIsLeftArrowVisible] = useState(false);
  const [isRightArrowVisible, setIsRightArrowVisible] = useState(true);

  const goNext = () => {
    if (controlledSwiper) {
      controlledSwiper.slideNext();
    }
  };

  const goPrev = () => {
    if (controlledSwiper) {
      controlledSwiper.slidePrev();
    }
  };

  const updateArrowsState = (event: any) => {
    if (event) {
      setIsLeftArrowVisible(!event.isBeginning);
      setIsRightArrowVisible(!event.isEnd);
    }
  };

  return (
    <>
      <LeftArrowContainer isVisible={isLeftArrowVisible} onClick={goPrev}>
        <LeftArrow src={ArrowIcon} alt='left arrow' />
      </LeftArrowContainer>
      <Swiper
        spaceBetween={5}
        slidesPerView='auto'
        onSwiper={setControlledSwiper}
        onTransitionEnd={updateArrowsState}
      >
        {children}
      </Swiper>
      <RightArrowContainer isVisible={isRightArrowVisible} onClick={goNext}>
        <RightArrow src={ArrowIcon} alt='right arrow' />
      </RightArrowContainer>
    </>
  );
};
